import { render, staticRenderFns } from "./SignupConfirmationView.vue?vue&type=template&id=514f7bda&scoped=true&"
import script from "./SignupConfirmationView.vue?vue&type=script&lang=js&"
export * from "./SignupConfirmationView.vue?vue&type=script&lang=js&"
import style0 from "./SignupConfirmationView.vue?vue&type=style&index=0&id=514f7bda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514f7bda",
  null
  
)

export default component.exports